module.exports = __webpack_public_path__ + "media/brand/CardsLogo-2e635869.png";